import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

export const FakeInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 39px;
  margin-top: 5px;
  padding: 0 14px;
  border: 1px solid
    ${({ theme, open, disabled, outlineColor }) =>
      disabled
        ? 'rgba(0, 0, 0, 0.23)'
        : open
        ? outlineColor || theme.primary.main
        : outlineColor || 'rgba(0, 0, 0, 0.23)'};
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background-color: transparent;
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${({ theme, disabled, outlineColor }) =>
      disabled ? 'rgba(0, 0, 0, 0.23)' : outlineColor || theme.primary.main};
  }

  &:focus-within {
    border-color: ${({ theme, disabled, outlineColor }) =>
      disabled ? 'rgba(0, 0, 0, 0.23)' : outlineColor || theme.primary.main};
    outline: none;
  }
`

export const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid
    ${({ theme, disabled }) =>
      disabled ? 'rgba(0, 0, 0, 0.38)' : theme.text.primary};
  margin-left: 8px;
`

export const CalendarWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - 16px);
  overflow-y: auto;
`

export const ClearButton = styled.button`
  position: absolute;
  right: 30px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.54);
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
`
